import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { useModalOpen } from '@src/public/hooks/useModalOpen';

const Custom = ({ Content, maskClosable = true, onClose, ContentProps }) => {
    useModalOpen();

    const close = () => {
        onClose();
    };

    return (
        <div className={styles.wrap}>
            <div
                className={styles.mask}
                onClick={() => {
                    if (maskClosable) {
                        close();
                    }
                }}>
                <div
                    onClick={e => {
                        e.stopPropagation();
                    }}>
                    <Content close={close} {...ContentProps} />
                </div>
            </div>
        </div>
    );
};

Custom.propTypes = {
    Content: PropTypes.elementType,
    maskClosable: PropTypes.bool,
    onClose: PropTypes.func,
    ContentProps: PropTypes.object,
};

export default errorBoundary(Custom);
